import { logError } from '@zg-rentals/log-error';
import oneTrustUtils from 'app/shared/utils/oneTrustUtils';

const optimizelyUtils = {
  hasInitiated: false,
  initiate: () => {
    oneTrustUtils
      .waitForOptanon()
      .then(() => {
        if (!optimizelyUtils.hasInitiated) {
          optimizelyUtils.hasInitiated = true;
          // @ts-ignore
          window.Optanon.InsertScript(
            '//cdn.optimizely.com/js/1719570453.js',
            'head',
            null,
            null,
            3, // functional cookie
          );
        }
        return;
      })
      .catch((err) => {
        logError({
          error: err,
          errorType: 'Optimizely',
          context: {
            details: 'Optimizely: initializing optimizely script',
            root: 'utils/analytics/optimizely#initiate',
          },
        });
      });
  },
  track: () => {
    // @ts-ignore
    window.optimizely = window.optimizely || [];

    // optimizely object matches that of rental-manager-web
    // @ts-ignore
    window.optimizely.push({
      type: 'event',
      eventName: 'ltleases_cta',
      tags: {
        revenue: 0,
        value: 0.0,
      },
    });
  },
};

export default optimizelyUtils;
